import React, { Component } from "react";
import { withCompanies } from "../../../shared/containers/containerCompanies";
import { withServiceHistory } from "../../../shared/containers/contaynerServiceHistory";
import { states } from "../../../reducers/queriesStates";

import CmsTransferCompanyTools from "./CmsTools/CmsTransferCompanyTools";
import CmsDebtFilterTools from "./CmsTools/CmsDebtFilterTools";
import OwnershipAreasRadioBottoms from "./CmsTools/OwnershipAreasRadioBottoms";
import CmsCompaniesTable from "./CmsCompaniesTable";
import Icon from "../../../shared/items/static/icon";
import Input from "../../../shared/items/contols/input";
import CmsCreateOwnershipAreaTools from "./CmsTools/CmsCreateOwnershipAreaTools";
import HistoryIcon from "@mui/icons-material/History";
import CmsHistory from "../CmsHisory/CmsHistory";
import Preloader from "../../../shared/items/static/preloader";

import styles from "./cmsCompanies.module.scss";

import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";

let timeOutId = null;

class CmsCompanies extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedCompanies: [],
      viewOwnershipAreaId: null,
      toOwnershipAreaId: null,
      searchTerm: null,
      orderDesc: false,
      orderBy: null,
      count: -1,
      debtMonths: 0,
      debtMore: false,
      isOpenHistoryView: false,
      page: 1,
      filterAction: null,
    };
  }

  componentDidMount() {
    const { ownershipAreasDataState, onGetCompanies, ownershipAreas } = this.props;
    const { searchTerm, orderDesc, orderBy, count, debtMonths, debtMore, viewOwnershipAreaId } = this.state;

    if (viewOwnershipAreaId === null && !!ownershipAreas.ownershipAreas) {
      if (ownershipAreas.ownershipAreas[0]) {
        this.setState({ viewOwnershipAreaId: ownershipAreas.ownershipAreas[0].id });
      }
    }

    if (ownershipAreasDataState !== states.READY) {
      onGetCompanies({ searchTerm, orderDesc, orderBy, count, debtMonths, debtMore });
    }
  }

  componentDidUpdate(prevPeops) {
    const { ownershipAreas } = this.props;
    const { viewOwnershipAreaId } = this.state;

    if (viewOwnershipAreaId === null && !!ownershipAreas.ownershipAreas) {
      if (ownershipAreas.ownershipAreas[0]) {
        this.setState({ viewOwnershipAreaId: ownershipAreas.ownershipAreas[0].id });
      }
    }
  }

  onRadioBottomClick(viewOwnershipAreaId) {
    this.setState({ viewOwnershipAreaId });
  }

  onChangeSearchTerm(name, value) {
    clearTimeout(timeOutId);

    if (name === "searchTerm") {
      this.setState({ searchTerm: value });
    }

    if (name === "debtMonths") {
      this.setState({ debtMonths: value });
    }

    if (name === "debtMore") {
      this.setState({ debtMore: value });
    }

    const onSearchTerm = () => {
      const { onGetCompanies } = this.props;
      const { searchTerm, orderDesc, orderBy, count, debtMonths, debtMore } = this.state;
      onGetCompanies({ searchTerm, orderDesc, orderBy, count, debtMonths, debtMore });
    };

    timeOutId = setTimeout(onSearchTerm, 600);
  }

  onSelectCompanyHandler(selectedCompanies) {
    this.setState({ selectedCompanies });
  }

  onSetCompanisToOwnership() {
    const { onSetToOwnershitDataState } = this.props;
    const { viewOwnershipAreaId, selectedCompanies, toOwnershipAreaId } = this.state;

    if (toOwnershipAreaId !== null) {
      onSetToOwnershitDataState(viewOwnershipAreaId, toOwnershipAreaId, selectedCompanies);
    }
  }

  onSelectOwnershipArea(e) {
    this.setState({ toOwnershipAreaId: e.target.value });
  }

  onSelectDebt(e) {
    const { onGetCompanies } = this.props;
    const { searchTerm, orderDesc, orderBy, count, debtMore } = this.state;
    const debtMonths = e.target.value;

    onGetCompanies({ searchTerm, orderDesc, orderBy, count, debtMonths, debtMore });

    this.setState({ debtMonths });
  }

  onViewHistory() {
    const { onGetServiceHistory } = this.props;
    const { viewOwnershipAreaId, page, filterAction } = this.state;

    onGetServiceHistory({ ownershipAreaId: viewOwnershipAreaId, count: 10, action: filterAction, page });
    this.setState({ isOpenHistoryView: true });
  }

  onCloseModal() {
    this.setState({ isOpenHistoryView: false, page: 1, filterAction: null });
  }

  onChangePage(page) {
    const { onGetServiceHistory } = this.props;
    const { viewOwnershipAreaId, filterAction } = this.state;

    onGetServiceHistory({ ownershipAreaId: viewOwnershipAreaId, count: 10, action: filterAction, page });
    this.setState({ page });
  }

  onChangeFilter(filterAction) {
    const { onGetServiceHistory } = this.props;
    const { viewOwnershipAreaId, page } = this.state;

    onGetServiceHistory({ ownershipAreaId: viewOwnershipAreaId, count: 10, action: filterAction, page });
    this.setState({ filterAction });
  }

  render() {
    const { ownershipAreas, ownershipAreasDataState } = this.props;
    const { viewOwnershipAreaId, count, debtMonths, debtMore, selectedCompanies, isOpenHistoryView, page, searchTerm } = this.state;

    const ownershipArea = ownershipAreas.ownershipAreas
      ? ownershipAreas.ownershipAreas.filter((x) => {
          return x.id === viewOwnershipAreaId;
        })[0]
      : null;

    return (
      <div className={styles.cmsCompanies}>
        <div className={styles.searchContainer}>
          <div className={styles.searchCompanies}>
            <Input name="searchTerm" type="text" handleChangeStore={this.onChangeSearchTerm.bind(this)} placeholder="Поиск" />
            <div className={styles.container_searchBtn}>
              <Icon name="search" />
            </div>
          </div>

          <CmsDebtFilterTools
            onSelectDebt={this.onSelectDebt.bind(this)}
            debtMore={debtMore}
            debtMonths={debtMonths}
            onChangeSearchTerm={this.onChangeSearchTerm.bind(this)}
          />

          <div className={styles.ownershipAreasRadioBottoms}>
            <OwnershipAreasRadioBottoms
              isSerchFilter={searchTerm !== null && searchTerm !== ""}
              ownershipAreas={ownershipAreas.ownershipAreas}
              selectId={viewOwnershipAreaId}
              onHandleClick={this.onRadioBottomClick.bind(this)}
            />

            <CmsCreateOwnershipAreaTools />
          </div>
        </div>

        {ownershipAreasDataState !== states.READY ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Preloader />
          </div>
        ) : null}

        {!!ownershipArea ? (
          <>
            {isOpenHistoryView ? (
              <CmsHistory
                title={"История " + ownershipArea.title}
                onClose={this.onCloseModal.bind(this)}
                onChangeStore={this.onChangePage.bind(this)}
                onChangeFilter={this.onChangeFilter.bind(this)}
                page={page}
              />
            ) : null}

            <div style={{ display: "flex", alignItems: "center" }}>
              <h2>{ownershipArea.title}</h2>
              <TooltipWrapper title={`Открыть панель истории ${ownershipArea.title}`} position="top">
                <div className={styles.activetyHover} style={{ width: "50px" }} onClick={this.onViewHistory.bind(this)}>
                  <HistoryIcon fontSize="medium" />
                </div>
              </TooltipWrapper>
            </div>

            {selectedCompanies.length > 0 ? (
              <CmsTransferCompanyTools
                ownershipAreas={ownershipAreas.ownershipAreas}
                viewOwnershipAreaId={viewOwnershipAreaId}
                onSelectArea={this.onSelectOwnershipArea.bind(this)}
                handleClick={this.onSetCompanisToOwnership.bind(this)}
              />
            ) : null}

            <CmsCompaniesTable
              ownershipArea={ownershipArea}
              pageSize={count}
              onRowSelectionModelChange={this.onSelectCompanyHandler.bind(this)}
            />
          </>
        ) : null}
      </div>
    );
  }
}

export default withServiceHistory(withCompanies(CmsCompanies));
